import styled from "styled-components";
import { extendedSystemStyles } from "@mixins";
var styledSystemKeys = ["space", "layout", "grid"];
export default styled.ol.withConfig({
  displayName: "Fluid",
  componentId: "sc-nukfxi-0"
})(["display:grid;", ""], extendedSystemStyles(styledSystemKeys));